import { SVGProps } from 'react'

const BridgeMinimalistIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_8699_591829)">
      <path
        d="M13.1936 5.83944V5.4314C11.6046 5.06899 10.4142 3.64713 10.4142 1.94988V1.35429C10.4142 1.24462 10.3253 1.15576 10.2157 1.15576C10.106 1.15576 10.0171 1.24462 10.0171 1.35429V1.94988C10.0171 3.92044 8.41409 5.52339 6.4436 5.52339C4.47312 5.52339 2.87007 3.92035 2.87007 1.94988V1.35429C2.87007 1.24462 2.78121 1.15576 2.67154 1.15576C2.56188 1.15576 2.47302 1.24462 2.47302 1.35429V1.94988C2.47302 3.64713 1.28262 5.06892 -0.306396 5.4314V5.83944C0.119168 5.75162 0.519899 5.59509 0.88478 5.38326V8.30278H-0.306396V8.69984H2.47302V10.6851H0.686251V11.0822H4.65684V10.6851H2.87007V8.69984H10.0171V10.6851H8.23037V11.0822H12.201V10.6851H10.4142V8.69984H13.1936V8.30278H12.0024V5.38326C12.3673 5.59504 12.768 5.75163 13.1936 5.83944ZM2.47302 8.30285H1.28184V5.1264H1.27169C1.78049 4.74544 2.19403 4.24658 2.47301 3.66923L2.47302 8.30285ZM3.86272 8.30285H2.87007V3.6692C3.1101 4.16578 3.44841 4.60542 3.86272 4.96106V8.30285ZM5.45096 8.30285H4.25978V5.26255C4.62 5.50082 5.0219 5.6788 5.45096 5.7899V8.30285ZM7.03919 8.30285H5.84802V5.87088C6.04286 5.90035 6.24061 5.92051 6.4436 5.92051C6.64653 5.92051 6.84435 5.90035 7.03919 5.87088V8.30285ZM8.62743 8.30285H7.43625V5.78981C7.86531 5.67872 8.26721 5.50074 8.62743 5.26247V8.30285ZM10.0171 8.30285H9.02449V4.96112C9.4388 4.60549 9.77711 4.16585 10.0171 3.66926V8.30285ZM11.6054 5.1264V8.30285H10.4142V3.6692C10.6932 4.24655 11.1067 4.7454 11.6155 5.12636L11.6054 5.1264Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.0843748"
      />
    </g>
    <defs>
      <clipPath id="clip0_8699_591829">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(0.443604 0.119141)"
        />
      </clipPath>
    </defs>
  </svg>
)
export default BridgeMinimalistIcon
